import styled from "styled-components";
import { ReactComponent as WarningMessageIconSVG } from "../../assets/icons/warning_message_icon.svg";
import Icon from "../icon";
import { theme } from "../../helpers/theme";

interface WarningMessageProps {
    message: string;
}

export const WarningMessage = ({ message }: WarningMessageProps) => {

    return (
        <WarningMessageWraper>
            <Icon
                width="20px"
                height="20px"
                noPadding
                icon={<WarningMessageIconSVG />} />
            <Description>{message}</Description>
        </WarningMessageWraper>
    );
};

const WarningMessageWraper = styled.div`
display:flex;
flex-direction:row;
 `;
const Description = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: 400;
font-size: 14px;
line-height: 20px;
color: ${theme.colors.red01_alert};
padding-left:14.5px;
`;